export enum CarrierTypeEnum {
  Ups = "ups",
  Dhl = "dhl",
}

export interface CarrierResource {
  id: string;
  title: string;
  carrier_type: CarrierTypeEnum;
  carrier_params: Record<string, string>;
}

export type UpdateCarrierRequestBody = {
  title?: string;
  carrier_type?: CarrierTypeEnum;
};

export type CreateCarrierRequestBody = {
  title: string;
  carrier_type: CarrierTypeEnum;
};
